<div class="background-white card-section">
    <div class="dark-blue card-object mob-pad0">
        <div class="card-object-header1">
            <div class="d-flex width100 justify-content-between">
                <div class="mr10 ">
                    <img src="{{aemFragmentInfo?.logo?.variations[planCode.toLowerCase() +'_'+ variantCode.toLowerCase()]?.value}}"
                        class="partner-logo" alt="bajaj-finserv-logo"
                        (load)="isLogoLoaded(aemFragmentInfo?.cardColour?.variations[planCode.toLowerCase() +'_'+ variantCode.toLowerCase()]?.value , i)"
                        [hidden]="!isPartnerLogoLoaded">
                    <div class="skelt-load loader" *ngIf="!isPartnerLogoLoaded"></div>
                </div>
                <div class="right0 pad0-mobile pt-m width100">
                    <div class="d-flex width100 justify-content-between">
                        <div class="partner-name">
                            {{aemFragmentInfo?.productName?.variations[planCode.toLowerCase() +'_'+
                            variantCode.toLowerCase()]?.value}}
                        </div>
                        <div class="padnon mob-right float-right" *ngIf="tags">
                            <div class="ribbon-container">
                                <span class="pointy">{{tags}}</span>
                            </div>
                        </div>
                    </div>

                    <div class="partner-loan-type">
                        {{aemFragmentInfo?.principleName?.variations[planCode.toLowerCase() +'_'+
                        variantCode.toLowerCase()]?.value}}
                    </div>
                </div>
            </div>

        </div>
        <div class="card-object-body">
            <div class="approval-box no-padding" [ngClass]="featureHide ? 'hide-desktop' : ''">
                <div class="col-md-12 col-sm-12 col-xs-12 no-padding">
                    <div class="col-md-12 col-sm-12 col-xs-12" [ngClass]="selectedTenure ? 'no-padding mr-4' : ''">
                        <div class="pad0-mobile top-spc-10 bottom-spc-10 no-padding"
                            [ngClass]="selectedSumAssuredAddOn ? 'col-md-5 col-sm-5 col-xs-5': 'col-md-4 col-sm-4 col-xs-4'">
                            <div class="spc-btwn">
                                <div>
                                    <span class="text-center plan-sub-desc" *ngIf="selectedSumAssured">
                                        Rs.
                                        {{formatter.ConvertNumberToAmount(selectedSumAssured.toString())}}
                                    </span>

                                </div>


                                <div *ngIf="selectedSumAssuredAddOn">
                                    <div class="col-md-1 col-sm-2 col-xs-2 pad0 summary-plus-pad">
                                        <div class="plus-margin">
                                            <label class="plus-sign">+</label>
                                        </div>
                                    </div>

                                    <span class="text-center plan-sub-desc">
                                        Rs.
                                        {{formatter.ConvertNumberToAmount(selectedSumAssuredAddOn.toString())}}
                                    </span>
                                </div>
                            </div>
                            <div class="col-xs-12 pad0-mobile no-padding">
                                <label class="plan-sub-head">Coverage</label>
                            </div>

                        </div>

                        <div class="pad0-mobile top-spc-10 bottom-spc-10 no-padding"
                            [ngClass]="selectedSumAssuredAddOn ? 'col-md-3 col-sm-3 col-xs-3 ls-15': 'col-md-4 col-sm-4 col-xs-4'">
                            <div class="col-xs-12 pad0-mobile no-padding">
                                <span class="text-center plan-sub-desc">
                                    Rs.
                                    {{formatter.ToCurrency(totalGrossPremium.toString())}}
                                </span>
                            </div>
                            <div class="col-xs-12 pad0-mobile no-padding">
                                <label class="plan-sub-head">Premium</label>
                            </div>
                        </div>
                        <div *ngIf="!selectedTenure"
                            class="col-md-4 col-sm-4 col-xs-4 pad0-mobile top-spc-10 bottom-spc-10 no-padding"
                            [ngClass]="selectedSumAssuredAddOn ? 'ls-15': ''">
                            <div class="col-xs-12 pad0-mobile no-padding">
                                <span class="text-center plan-sub-desc">
                                    {{cashlessHospitalcount}}
                                </span>
                            </div>
                            <div class="col-xs-12 pad0-mobile no-padding">
                                <label class="plan-sub-head">Cashless Hospital</label>
                            </div>
                        </div>

                        <div *ngIf="selectedTenure"
                            class="col-md-4 col-sm-4 col-xs-4 pad0-mobile top-spc-10 bottom-spc-10 no-padding">
                            <div class="col-xs-12 pad0-mobile no-padding">
                                <span class="text-center plan-sub-desc">
                                    {{selectedTenure}} {{selectedTenure === 1 ? 'Year': 'Years'}}
                                </span>
                            </div>
                            <div class="col-xs-12 pad0-mobile no-padding">
                                <label class="plan-sub-head">Tenure</label>
                            </div>
                        </div>

                    </div>

                </div>
                <div class="col-md-12 col-sm-12 col-xs-12 no-padding usp-section">
                    <div class="claim-txt">
                        <div *ngTemplateOutlet="offerIcon;">
                        </div>
                        <div [innerHTML]="aemFragmentInfo?.USP1?.variations[planCode.toLowerCase() +'_'+ variantCode.toLowerCase()]?.value"
                            class="claim-txt">
                        </div>
                    </div>
                    <div class="mb-10 d-flex usp-txt" *ngIf="aemFragmentInfo?.USP2?.variations[planCode.toLowerCase()
                    +'_'+ variantCode.toLowerCase()]?.value">
                        <img src="./assets/img/offers-logo.svg" class="offers-img">
                        <div [innerHTML]="aemFragmentInfo?.USP2?.variations[planCode.toLowerCase()
                                                     +'_'+ variantCode.toLowerCase()]?.value">
                        </div>
                    </div>
                    <div class="mb-10 d-flex usp-txt" *ngIf="aemFragmentInfo?.USP3?.variations[planCode.toLowerCase()
                    +'_'+ variantCode.toLowerCase()]?.value">
                        <img src="./assets/img/offers-logo.svg" class="offers-img">
                        <div [innerHTML]="aemFragmentInfo?.USP3?.variations[planCode.toLowerCase()
                                                         +'_'+ variantCode.toLowerCase()]?.value">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

<ng-content></ng-content>

<div class="col-xs-12 col-md-12 hide-mobile no-padding" *ngIf="!featureHide">
    <div class="side-section-spc">
        <h5 class="coverage-amt-label bottom-spc-20 ">Key Features and Benefits</h5>
        <span class="popup-feature-content"
            [innerHTML]="aemFragmentInfo?.KeyFeaturesandBenefits?.variations[planCode.toLowerCase() +'_'+ variantCode.toLowerCase()]?.value"></span>
        <h5 class="coverage-amt-label bottom-spc-20">Downloads</h5>
        <div class="lato-heavy popup-feature-content center downloads-link">
            <span class="cursor-pointer"
                (click)="$event.preventDefault();DownloadBrochure(aemFragmentInfo?.Brochure?.variations[planCode.toLowerCase() +'_'+ variantCode.toLowerCase()]?.value); googleAnalyticDownload('Brochure'); handleCtBrochure();">BROCHURE</span>
            <span class="icon icon-Bajaj_Icon_Cybersafe_01_download cursor-pointer"
                (click)="$event.preventDefault();DownloadBrochure(aemFragmentInfo?.Brochure?.variations[planCode.toLowerCase() +'_'+ variantCode.toLowerCase()]?.value); googleAnalyticDownload('Brochure'); handleCtBrochure();"></span>
        </div>
        <div class="lato-heavy popup-feature-content center downloads-link">
            <span class="cursor-pointer"
                (click)="$event.preventDefault();DownloadBrochure(aemFragmentInfo?.PolicyWording?.variations[planCode.toLowerCase() +'_'+ variantCode.toLowerCase()]?.value); googleAnalyticDownload('Policy Wording'); handleCtPolicy();">POLICY
                WORDINGS</span>
            <span class="icon icon-Bajaj_Icon_Cybersafe_01_download cursor-pointer"
                (click)="$event.preventDefault();DownloadBrochure(aemFragmentInfo?.PolicyWording?.variations[planCode.toLowerCase() +'_'+ variantCode.toLowerCase()]?.value); googleAnalyticDownload('Policy Wording'); ; handleCtPolicy();"></span>
        </div>
    </div>
</div>
<ng-template #offerIcon>
    <svg xmlns="http://www.w3.org/2000/svg" class="ml-5px mr-5px" width="15" height="22.145"
        viewBox="0 0 17.378 22.145">
        <g id="Icons_Offer_icon_-_cards">
            <path id="Path_31078"
                d="M23.407 22.436a.328.328 0 0 0 .328-.328V11.986a1.79 1.79 0 0 0-.461-1.1l-2.345-2.934a1.806 1.806 0 0 0-.43-.383 1.994 1.994 0 0 0 0-.3V3.63a.34.34 0 0 0-.68 0v3.681h-4.463a1.7 1.7 0 0 0-.844.234l-3.166 1.564a1.7 1.7 0 0 0-.782.829l-2.923 7.2a.328.328 0 0 0 .18.422.3.3 0 0 0 .117 0 .32.32 0 0 0 .3-.2l2.862-7.211a1.04 1.04 0 0 1 .485-.5l1.673-.782-1.658 2.017A1.727 1.727 0 0 0 11.221 12v11.194a2.126 2.126 0 0 0 .039.383l-3.345-1.485a1.5 1.5 0 0 1-.782-1.978l2.11-5.253a.313.313 0 0 0-.18-.422.32.32 0 0 0-.422.18l-2.11 5.253a2.149 2.149 0 0 0 1.11 2.814l3.908 1.735a2.212 2.212 0 0 0 1.868 1.032h8.043a2.345 2.345 0 0 0 2.275-2.267v-1.9a.328.328 0 0 0-.657 0v1.907a1.641 1.641 0 0 1-1.618 1.618h-8a1.563 1.563 0 0 1-1.563-1.618V11.986a1.1 1.1 0 0 1 .227-.7l2.407-2.915a1.11 1.11 0 0 1 .844-.43h4.385A2.446 2.446 0 0 1 18.365 9.5a1.016 1.016 0 1 0 .141.649 3.126 3.126 0 0 0 1.829-1.892l.078.094 2.407 2.915a1.11 1.11 0 0 1 .274.7v10.165a.328.328 0 0 0 .328.328zm-5.933-12.029a.367.367 0 1 1 .375-.367.375.375 0 0 1-.375.367z"
                class="cards-offer-icon-color" transform="translate(-6.357 -3.308)" />
            <path id="Path_31079"
                d="M16.909 23.677a.328.328 0 0 0 .227-.094l5.542-5.542a.328.328 0 0 0-.461-.461l-5.542 5.542a.328.328 0 0 0 .234.555z"
                class="cards-offer-icon-color" transform="translate(-8.59 -6.409)" />
            <path id="Path_31080"
                d="M17.437 20.215a1.407 1.407 0 1 0 0-2.806H17.4a1.407 1.407 0 1 0 0 2.806zm-.782-1.407a.782.782 0 0 1 .782-.782h.039a.782.782 0 1 1 0 1.509h-.039a.782.782 0 0 1-.8-.711z"
                class="cards-offer-icon-color" transform="translate(-8.438 -6.386)" />
            <path id="Path_31081"
                d="M22.847 24.614h.047a1.407 1.407 0 0 0 0-2.814h-.047a1.407 1.407 0 1 0 0 2.814zm0-2.165h.047a.782.782 0 1 1 0 1.516h-.047a.782.782 0 0 1 0-1.516z"
                class="cards-offer-icon-color" transform="translate(-9.651 -7.346)" />
        </g>
    </svg>
</ng-template>